// extracted by mini-css-extract-plugin
export default {"spotlightOverlay":"SpotlightOverlay_spotlightOverlay__a-MSF"};